import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { modalStyle } from "../../components/modalStyle";

export default function LogoutModal({
  openDeleteModal,
  setOpenDeleteModal,
  onModalLogout,
}) {
  const handleClose = () => setOpenDeleteModal(false);

  return (
    <div>
      <Modal
        open={openDeleteModal}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{ ...modalStyle, border: "", maxWidth: 500, p: 3 }}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Are you sure you want to Logout ?
          </Typography>
          {/* 
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            when you logout, 
          </Typography> */}

          <Box textAlign="right" sx={{ pt: 3 }}>
            <Button
              variant="contained"
              color="error"
              sx={{ mx: 0.5 }}
              onClick={onModalLogout}
            >
              Sign out
            </Button>
            <Button
              variant="outlined"
              color="error"
              sx={{ mx: 0.5 }}
              onClick={handleClose}
            >
              Close
            </Button>
          </Box>
        </Box>
      </Modal>
    </div>
  );
}
